import Vue from 'vue'
import VueStepWizard from 'vue-step-wizard'
Vue.use(VueStepWizard);
